import { render, staticRenderFns } from "./BackendUyJoySynchronization.vue?vue&type=template&id=514aa8c6&scoped=true&"
import script from "./BackendUyJoySynchronization.vue?vue&type=script&lang=js&"
export * from "./BackendUyJoySynchronization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514aa8c6",
  null
  
)

export default component.exports